/** Compatibile Android/ZION — MessageDeleteControl.kt + ZionControl.CHAT_DEL */
export const MSG_DELETE_NOTIFY_PREFIX = 'NYXIA_MSG_DELETE::'
/** Protocollo ZION Android (ZionControl.kt) — NON NYXIA_CHAT_CLEAR */
export const CHAT_CLEAR_NOTIFY = 'ZION::CHAT_DEL'
const LEGACY_CHAT_CLEAR_NOTIFY = 'NYXIA_CHAT_CLEAR::'

export function buildMessageDeleteNotify(messageId: string): string {
  return `${MSG_DELETE_NOTIFY_PREFIX}${messageId.trim()}`
}

export function parseMessageDeleteNotify(text: string): string | null {
  const t = text.trim()
  if (!t.startsWith(MSG_DELETE_NOTIFY_PREFIX)) return null
  const id = t.slice(MSG_DELETE_NOTIFY_PREFIX.length).trim()
  return id || null
}

export function buildChatClearNotify(): string {
  return CHAT_CLEAR_NOTIFY
}

export function parseChatClearNotify(text: string): boolean {
  const t = text.trim()
  return t === CHAT_CLEAR_NOTIFY || t === LEGACY_CHAT_CLEAR_NOTIFY
}
